module.exports = __webpack_public_path__ + "static/media/dumpster-fire.a0c85299.svg";